export enum HRDPEnvironment {
    NonProduction = 0,
    Production = 1
  }
  